export const guestTypes = {
    loading: "LOADING_GUEST",
    delete: "DELETE_GUEST",
    loadedOne: "LOADED_GUEST",
    loadedMultiple: "LOADED_GUESTS",
    success: "SUCCESS_GUEST",
    restore: "RESTORE_GUEST",
    hardDelete: "HARDDELETE_GUEST",
};
